
import { URL_checkUsername, URL_checkEmail} from "../Utils/Strings/URL.js";
import * as actionType from "../Actions/Action_Type";

//checkUsername
export const checkUsername_request = () => ({
  type       : actionType.SERVICE_CHECK_USERNAME_REQUEST,
  isFetching : true
});
export const checkUsername_success = () => ({
  type: actionType.SERVICE_CHECK_USERNAME_SUCCESS,
  isFetching      : false,
});
export const checkUsername_error = error => ({
  type: actionType.SERVICE_CHECK_USERNAME_ERROR,
  isFetching : false,
  error
});

export const checkUsername = (username) => {
  let config = {
      method  : 'GET',
      headers : { 'Content-Type': 'application/json' }
  };
  return dispatch => {
      dispatch(checkUsername_request());
      return fetch(URL_checkUsername+"?Username="+username, config)
        .then(response =>
          response.json().then(service => ({ service, response }))
        )
        .then(({ service, response }) => {
          if (!service.Data) {
            return Promise.reject(service);
          } else {
            dispatch(checkUsername_success());
          }
        })
        .catch(err => {
           dispatch(checkUsername_error(err.Message));
          }
      );
  };
};

//checkPassword
export const checkEmail_request = () => ({
  type       : actionType.SERVICE_CHECK_EMAIL_REQUEST,
  isFetching : true
});
export const checkEmail_success = () => ({
  type: actionType.SERVICE_CHECK_EMAIL_SUCCESS,
  isFetching      : false,
});
export const checkEmail_error = error => ({
  type: actionType.SERVICE_CHECK_EMAIL_ERROR,
  isFetching : false,
  error
});

export const checkEmailService = (email) => {
  let config = {
      method  : 'GET',
      headers : { 'Content-Type': 'application/json' }
  };
  return dispatch => {
      dispatch(checkEmail_request());
      return fetch(URL_checkEmail+"?Email="+email, config)
        .then(response =>
          response.json().then(service => ({ service, response }))
        )
        .then(({ service, response }) => {
          if (!service.Data) {
            return Promise.reject(service);
          } else {
            dispatch(checkEmail_success());
          }
        })
        .catch(err => {
           dispatch(checkEmail_error(err.Message));
          }
      );
  };
};


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_CheckValue.js